/* eslint-disable prettier/prettier */
/* eslint-disable */
/* CreateActivityModal.tsx */

import React from 'react';
import styles from './CreateActivityModal.module.css';
import Dropdown from '../../../controlVariations/DropdownProgram';
import calander from '../../../../assets/coach/cl.png';

export interface DropdownOption {
	label: string;
	value: string;
}

export interface CreateActivityModalProps {
	isOpen: boolean;
	onClose: () => void;

	title?: string;

	/* Program Dropdown */
	selectedProgram?: string;
	programOptions: DropdownOption[];
	onProgramSelect: (value: string) => void;

	/* Module Dropdown */
	selectedModule?: string;
	moduleOptions: DropdownOption[];
	onModuleSelect: (value: string) => void;

	/* Activity Type Dropdown */
	selectedActivityType?: string;
	activityTypeOptions: DropdownOption[];
	onActivityTypeSelect: (value: string) => void;

	/* Activity Type Action */
	newActivityTypeText?: string;
	onNewActivityType?: () => void;

	/* Activity Title */
	activityTitle?: string;
	activityTitlePlaceholder?: string;
	onActivityTitleChange: (value: string) => void;
	titleMaxLength?: number;

	/* Description */
	activityDescription?: string;
	activityDescriptionPlaceholder?: string;
	onActivityDescriptionChange: (value: string) => void;

	/* Date */
	date?: string;
	onDateChange: (value: string) => void;

	/* Time */
	startTime?: string;
	endTime?: string;
	onStartTimeChange: (value: string) => void;
	onEndTimeChange: (value: string) => void;

	/* Schedule Text */
	scheduleText?: string;

	/* Participants */
	/* Participants Dropdown */
	showParticipants?: boolean;

	selectedParticipant?: string;
	participantOptions?: DropdownOption[];
	onParticipantSelect?: (value: string) => void;

	participantPlaceholder?: string;
	// participants?: string[];
	// participantsPlaceholder?: string;

	/* Button */
	buttonText?: string;
	onSubmit: () => void;

	disabled?: boolean;
	errors?: any;
	submitError?: string;
}

const CreateActivityModal: React.FC<CreateActivityModalProps> = ({
	isOpen,
	onClose,

	title = 'Create Activity',

	selectedProgram,
	programOptions,
	onProgramSelect,

	selectedModule,
	moduleOptions,
	onModuleSelect,

	selectedActivityType,
	activityTypeOptions,
	onActivityTypeSelect,

	newActivityTypeText = 'New Activity Type',
	onNewActivityType,

	activityTitle = '',
	activityTitlePlaceholder = 'Enter activity title',
	onActivityTitleChange,
	titleMaxLength = 60,

	activityDescription = '',
	activityDescriptionPlaceholder = 'Enter details about activity(Optional)',
	onActivityDescriptionChange,

	date = '',
	onDateChange,

	startTime = '',
	endTime = '',
	onStartTimeChange,
	onEndTimeChange,

	scheduleText = '',

	// participants = [],
	// participantsPlaceholder = 'No Participants',
	showParticipants = false,

	selectedParticipant,
	participantOptions = [],
	onParticipantSelect,

	participantPlaceholder = 'Select Participant',

	buttonText = 'Create Activity',
	onSubmit,

	disabled = false,
	errors = {},
	submitError = '',
}) => {
	if (!isOpen) return null;

	// const hourOptions = Array.from({ length: 24 }, (_, i) => ({
	// 	label: String(i).padStart(2, '0'),
	// 	value: String(i).padStart(2, '0'),
	// }));
	const now = new Date();

const selectedDate = date ? new Date(date) : null;

const isToday =
	selectedDate &&
	selectedDate.toDateString() === now.toDateString();

const currentHour = now.getHours();
const currentMinute = now.getMinutes();
const hourOptions = Array.from({ length: 24 }, (_, i) => ({
	label: String(i).padStart(2, '0'),
	value: String(i).padStart(2, '0'),
})).filter(option => {
	if (!isToday) return true;

	return Number(option.value) >= currentHour;
});
const getMinuteOptions = (selectedHour: string) => {
	return Array.from({ length: 60 }, (_, i) => ({
		label: String(i).padStart(2, '0'),
		value: String(i).padStart(2, '0'),
	})).filter(option => {
		if (!isToday) return true;

		const hour = Number(selectedHour);

		if (hour > currentHour) return true;

		if (hour === currentHour) {
			return Number(option.value) >= currentMinute;
		}

		return false;
	});
};

	const minuteOptions = Array.from({ length: 60 }, (_, i) => ({
		label: String(i).padStart(2, '0'),
		value: String(i).padStart(2, '0'),
	}));

	const [startHour, startMinute] = startTime.split(':');

const getEndHourOptions = () => {
	if (!startHour) {
		return Array.from({ length: 24 }, (_, i) => ({
			label: String(i).padStart(2, '0'),
			value: String(i).padStart(2, '0'),
		}));
	}

	const startHourNum = Number(startHour);

	return Array.from({ length: 24 }, (_, i) => ({
		label: String(i).padStart(2, '0'),
		value: String(i).padStart(2, '0'),
	})).filter(option => Number(option.value) >= startHourNum);
};

const getEndMinuteOptions = (selectedEndHour: string) => {
	if (!startHour || !startMinute) {
		return minuteOptions;
	}

	const startHourNum = Number(startHour);
	const endHourNum = Number(selectedEndHour);

	// Same hour → minutes must be greater than start minute
	if (endHourNum === startHourNum) {
		return minuteOptions.filter(
			option => Number(option.value) > Number(startMinute)
		);
	}

	// Later hour → all minutes allowed
	return minuteOptions;
};
const truncateText = (text: string, maxLength: number) => {
	if (!text) return '';

	return text.length > maxLength
		? `${text.substring(0, maxLength)}...`
		: text;
};

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{/* Header */}
				<div className={styles.header}>
					<h2 className={styles.title}>{title}</h2>

					<button className={styles.closeButton} onClick={onClose}>
						✕
					</button>
				</div>

				{/* Row 1 */}
				<div className={styles.row}>
					<div className={styles.field}>
						<label className={styles.label}>
							Select Program
							<span className={styles.required}>*</span>
						</label>

						<Dropdown
							placeholder="Select Program"
							options={programOptions}
							selected={truncateText(selectedProgram || '', 35)}
							onSelect={onProgramSelect}
							width="100%"
							height="46px"
						/>
						{errors.program && (
							<p className={styles.errorText}>{errors.program}</p>
						)}
					</div>

					<div className={styles.field}>
						<label className={styles.label}>
							Select Module
							<span className={styles.required}>*</span>
						</label>

						<Dropdown
							placeholder="Select Module"
							options={moduleOptions}
							selected={selectedModule}
							onSelect={onModuleSelect}
							width="100%"
							height="46px"
							disabled={!selectedProgram}
						/>
						{errors.module && (
							<p className={styles.errorText}>{errors.module}</p>
						)}
					</div>
				</div>

				{/* Activity Type */}
				<div className={styles.fullField}>
					<div className={styles.activityTypeHeader}>
						<label className={styles.label}>
							Activity Type
							<span className={styles.required}>*</span>
						</label>

						<button
							type="button"
							className={styles.newTypeButton}
							onClick={onNewActivityType}
						>
							{newActivityTypeText} +
						</button>
					</div>

					<Dropdown
						placeholder="Select Activity Type"
						options={activityTypeOptions}
						selected={selectedActivityType}
						onSelect={onActivityTypeSelect}
						width="100%"
						height="46px"
					/>
					{errors.activityType && (
						<p className={styles.errorText}>
							{errors.activityType}
						</p>
					)}
				</div>

				{/* Activity Title */}
				<div className={styles.fullField}>
					<div className={styles.titleRow}>
						<label className={styles.label}>
							Activity Title
							<span className={styles.required}>*</span>
						</label>

						<span className={styles.counter}>
							{activityTitle.length}/{titleMaxLength}
						</span>
					</div>

					<input
						type="text"
						value={activityTitle}
						maxLength={titleMaxLength}
						placeholder={activityTitlePlaceholder}
						onChange={e => onActivityTitleChange(e.target.value)}
						className={styles.input}
						disabled={disabled}
					/>
					{errors.title && (
						<p className={styles.errorText}>{errors.title}</p>
					)}
				</div>

				{/* Description */}
				<div className={styles.fullField}>
					<label className={styles.label}>Activity Description</label>

					<textarea
						value={activityDescription}
						placeholder={activityDescriptionPlaceholder}
						onChange={e =>
							onActivityDescriptionChange(e.target.value)
						}
						className={styles.textarea}
						disabled={disabled}
					/>
				</div>

				{/* Date & Time */}
				<div className={styles.scheduleContainer}>
					<div className={styles.dateField}>
						<label className={styles.label}>
							Date
							<span className={styles.required}>*</span>
						</label>
                          <div className={styles.dateInputWrapper}>
						<img
			src={calander}
			alt="calendar"
			className={styles.metaIcon}
		/>


						<input
							type="date"
							value={date}
							onChange={e => onDateChange(e.target.value)}
							className={styles.input}
							min={new Date().toISOString().split('T')[0]}
						/>
						</div>
						{errors.date && (
							<p className={styles.errorText}>{errors.date}</p>
						)}
					</div>

					<div className={styles.timeSection}>
						<label className={styles.label}>
							Time Slot
							<span className={styles.required}>*</span>
						</label>

					
						<div className={styles.timeSlotWrapper}>
							{/* START TIME */}
							<div className={styles.timeGroup}>
								<div className={styles.timeField}>
									<span className={styles.timeLabel}>HH</span>

									<Dropdown
										placeholder="00"
										options={hourOptions}
										selected={startTime.split(':')[0] || ''}
										onSelect={value => {
											const mm =
												startTime.split(':')[1] || '00';

											onStartTimeChange(`${value}:${mm}`);
										}}
										width="80px"
										height="44px"
									/>
								</div>

								<div className={styles.timeField}>
									<span className={styles.timeLabel}>MM</span>

									<Dropdown
										placeholder="00"
										// options={minuteOptions}
										options={getMinuteOptions(startTime.split(':')[0] || '')}
										selected={startTime.split(':')[1] || ''}
										onSelect={value => {
											const hh =
												startTime.split(':')[0] || '00';

											onStartTimeChange(`${hh}:${value}`);
										}}
										width="80px"
										height="44px"
									/>
								</div>
							</div>

							<span className={styles.toText}>to</span>

							{/* END TIME */}
							<div className={styles.timeGroup}>
								<div className={styles.timeField}>
									<span className={styles.timeLabel}>HH</span>

									<Dropdown
										placeholder="00"
										options={getEndHourOptions()}
										selected={endTime.split(':')[0] || ''}
										onSelect={value => {
											const mm =
												endTime.split(':')[1] || '00';

											onEndTimeChange(`${value}:${mm}`);
										}}
										width="80px"
										height="44px"
									/>
								</div>

								<div className={styles.timeField}>
									<span className={styles.timeLabel}>MM</span>

									<Dropdown
										placeholder="00"
										options={getEndMinuteOptions(endTime.split(':')[0] || '')}
										selected={endTime.split(':')[1] || ''}
										onSelect={value => {
											const hh =
												endTime.split(':')[0] || '00';

											onEndTimeChange(`${hh}:${value}`);
										}}
										width="80px"
										height="44px"
									/>
								</div>
							</div>
						</div>

						{errors.startTime && (
							<p className={styles.errorText}>
								{errors.startTime}
							</p>
						)}

						{errors.endTime && (
							<p className={styles.errorText}>{errors.endTime}</p>
						)}
					</div>
				</div>

				{/* Participants */}
				{/* <div className={styles.fullField}>
                    <label className={styles.label}>
                        Participants
                    </label>

                    <div className={styles.participantsBox}>
                      
{showParticipants && (
    <div className={styles.fullField}>
        <label className={styles.label}>
            Participants
        </label>

        <Dropdown
            placeholder={
                participantPlaceholder ||
                'Select Participant'
            }
            options={participantOptions || []}
            selected={selectedParticipant}
            onSelect={(value) =>
                onParticipantSelect?.(value)
            }
            width="100%"
            height="46px"
        />
    </div>
)}
                    </div>
                </div> */}
				{/* Participants Dropdown */}
				{showParticipants && (
					<div className={styles.fullField}>
						<label className={styles.label}>
							Participants
							<span className={styles.required}>*</span>
						</label>

						<Dropdown
							placeholder={
								participantPlaceholder || 'Select Participant'
							}
							options={participantOptions || []}
							selected={selectedParticipant}
							onSelect={value => onParticipantSelect?.(value)}
							width="100%"
							height="46px"
						/>
						{errors.participant && (
							<p className={styles.errorText}>
								{errors.participant}
							</p>
						)}
					</div>
				)}

				{/* Footer */}
				{submitError && (
					<div className={styles.submitError}>{submitError}</div>
				)}
				{/* <button className={styles.submitButton} onClick={onSubmit}>
					{buttonText} +
				</button> */}
				<button
	className={styles.submitButton}
	onClick={onSubmit}
	disabled={disabled}
>
	{disabled ? 'Creating...' : `${buttonText} +`}
</button>
			</div>
		</div>
	);
};

export default CreateActivityModal;
